import axios from "axios"

const getPublishableKey = ({}) => {
    return axios.get("api/stripe/publishable-key")
}

const getInvoiceIntent = ({ email, invoiceId }) => {
    return axios.get(`api/stripe/invoice-intent/${email}/${invoiceId}`)
}

export const paymentService = {
    getPublishableKey,
    getInvoiceIntent,
}
